import { render, staticRenderFns } from "./VxTimeline.vue?vue&type=template&id=588967f2&"
import script from "./VxTimeline.vue?vue&type=script&lang=js&"
export * from "./VxTimeline.vue?vue&type=script&lang=js&"
import style0 from "./VxTimeline.vue?vue&type=style&index=0&id=588967f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports